import { timelineQuestionsComponent } from './timeline-questions.component';
import './timeline-questions-list.scss';

export const timelineQuestionsList = angular
	.module('components.timeline.timelineQuestionsList', [])
	.component('timelineQuestionsList', timelineQuestionsComponent)
	.config(($stateProvider) => {
		'ngInject';

		$stateProvider
			.state('timelineQuestionsList', {
			    parent: 'app',
                url: '/home/timeline/:id/timeline-list/timeline-questions-user-details?page_id&limit&sort_by',
				breadcrumbName: 'survey User Questions Details	',
				parentState: 'timeline',
                component: 'timelineQuestionsList',
                resolve: {
                    details($stateParams,TimelineService){
                        'ngInject';
                        return TimelineService.getSurveyUserDeatilsById($stateParams);
                    }
                    
                }
			});
	})
	.name;


// WEBPACK FOOTER //
// ./src/app/components/timeline/timeline-questions/timeline-questions-list.module.js